import React, { useState } from "react";
import filterIcon from "../styles/svg/switch_filter.svg";
import greyFilterIcon from "../styles/svg/greyFilter.svg";

function ToggleInput({ value, setValue }) {
  return (
    <>
      <label className="switch_tgl">
        <input
          type="checkbox"
          value={value}
          checked={value}
          onChange={(e) => {
            setValue(e.target.checked);
          }}
        />
        <div
          className={`slider_tgl d-flex align-items-center ${
            value ? "" : "justify-content-end"
          } 
          ${value ? " bg-primary" : "bg-primary-light"}`}
          style={{
            "--bg-img": value ? `url(${filterIcon})` : `url(${greyFilterIcon})`,
          }}></div>
      </label>
    </>
  );
}

export default React.memo(ToggleInput);
